'use es6';

import http from 'hub-http/clients/apiClient';
import formatChatflowsByUniqueId from 'reference-resolvers/formatters/formatChatflowsByUniqueId';
export const createGetChatflowsByUniqueId = ({
  httpClient
}) => idsToFetch => httpClient.post('chatflows/v2/channel-instance/chatflow-ids/batch?deletedFilter=ALL', {
  data: idsToFetch
}).then(formatChatflowsByUniqueId);
export const getChatflowsByUniqueId = createGetChatflowsByUniqueId({
  httpClient: http
});